<template>
  <div class="relationship-list">
    <div
      class="mt-4 block border-2 rounded border-gray-100"
    >
      <h2
        class="p-2 pl-4 border-b-2 border-gray-100 w-full bg-gray-50 block uppercase tracking-wide text-gray-700 text-xs font-semibold"
        style="margin-bottom: 22px"
      >
        Relationships

        <el-button
          class="ml-3"
          size="mini"
          type="primary"
          @click="newRelationship()"
          ><i class="fas fa-plus mr-1"></i> New
          Relationship</el-button
        >
      </h2>

      <el-table :data="listForTable" style="width: 100%">
        <el-table-column
          prop="type"
          label="Type"
        ></el-table-column>
        <el-table-column
          prop="entityA"
          label="Entity A"
        ></el-table-column>
        <el-table-column
          prop="fieldNameA"
          label="Field Name A"
        ></el-table-column>
        <el-table-column
          prop="entityB"
          label="Entity B"
        ></el-table-column>
        <el-table-column
          prop="fieldNameB"
          label="Field Name B"
        ></el-table-column>
        <!-- <el-table-column
          prop="embeddedEntity"
          label="Embedded Entity"
        ></el-table-column> -->

        <el-table-column label="Actions">
          <template slot-scope="scope">
            <div v-if="scope.row.preDefined">
              <el-button
                size="small"
                disabled
                icon="el-icon-lock"
              ></el-button>
            </div>

            <div v-if="!scope.row.preDefined">
              <el-button
                size="small"
                @click="edit(scope.row)"
                ><i class="far fa-edit"></i>
              </el-button>
              <el-button
                size="small"
                type="danger"
                @click="remove(scope.row)"
                ><i class="fas fa-trash"></i
              ></el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { relationshipTypeLabel } from './relationship-type-label';

export default {
  name: 'app-relationship-list',

  computed: {
    ...mapGetters({
      data: 'builder/data',
      list: 'builder/relationshipCurrent/list',
      scaffold: 'scaffold/current',
      showPreDefined: 'builder/showPreDefined',
    }),

    listForTable() {
      const entities = this.data.entities;

      let output = [];

      output = this.list.map((item) => {
        const entityA = entities.find(
          (entity) => entity.id === item.entityA,
        );

        const entityB = entities.find(
          (entity) => entity.id === item.entityB,
        );

        const embeddedEntity = entities.find(
          (entity) => entity.id === item.embeddedEntity,
        );

        return {
          ...item,
          entityA: entityA && entityA.name.singular,
          entityB:
            (entityB && entityB.name.singular) ||
            item.entityB,
          embeddedEntity:
            embeddedEntity && embeddedEntity.name.singular,
          type: relationshipTypeLabel(item.type),
        };
      });

      return output;
    },
  },

  methods: {
    newRelationship() {
      this.$router.push({
        name: 'relationship-new',
        params: {
          scaffoldId: this.scaffold.id,
        },
      });
    },

    edit(relationship) {
      this.$router.push({
        name: 'relationship-edit',
        params: {
          scaffoldId: this.scaffold.id,
          id: relationship.id,
          reload: true,
        },
      });
    },

    remove(relationship) {
      const { dispatch } = this.$store;
      dispatch(
        'builder/relationshipCurrent/delete',
        relationship,
      );
    },
  },
};
</script>

<style></style>
